import React from 'react';
import { DebugModal, DebugGrid, useDebugGrid } from '../../context/Debug';
import { useScrollToAnchorTag } from '../../utils';
import FloatingChatBubble from '../generic/FloatingChatBubble';
import QuoteView from '../QuoteView';

/**
 * @deprecated
 *
 *  please see the `./PwpLayout.js`
 *  or `../../webex/WebexLayout.js` for change to the layout component.
 */
export default function Layout() {
  return null;
}

/**
 * layout elements shared between Webex & Pwp Layout
 * @param {object} props
 * @param {string} props.location
 * @param {React.ReactNode} [props.children]
 */
export function SharedLayout({ location, children = null }) {
  let debugGrid = useDebugGrid();
  useScrollToAnchorTag(location);
  return (
    <>
      <QuoteView />
      <FloatingChatBubble />
      {children}
      {debugGrid && (
        <DebugModal full>
          <DebugGrid />
        </DebugModal>
      )}
      <div id="modal-root" className="pwp" />
    </>
  );
}
